// Bail / detention status. Reads matter.workspace.bail (loose shape).
// Shows: bail type, dollar amount, conditions chips. Empty state when
// no bail data is on the matter (custody case without seeded workspace).

import { pick, type WidgetProps } from "./types";
import type { BailShape } from "../workspace-shapes";
import { WidgetCard } from "./WidgetCard";

export function BailStatusWidget({ config, matter }: WidgetProps) {
  const bail = pick<BailShape>(matter.workspace, "bail");
  const title = config.title ?? "Bail status";

  if (!bail) {
    return (
      <WidgetCard title={title}>
        <div style={{ fontSize: 12.5, color: "var(--muted)" }}>No bail data on this matter.</div>
      </WidgetCard>
    );
  }

  return (
    <WidgetCard title={title} sub={bail.type ?? "—"}>
      <div style={{ marginBottom: 10 }}>
        <div
          style={{
            fontSize: 9.5,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "var(--muted)",
          }}
        >
          Amount
        </div>
        <div
          style={{
            fontVariantNumeric: "tabular-nums",
            fontSize: 18,
            fontWeight: 700,
            letterSpacing: "-0.03em",
            color: "var(--ink)",
          }}
        >
          {bail.amount != null ? `$${bail.amount.toLocaleString()}` : "—"}
        </div>
      </div>
      {bail.conditions && bail.conditions.length > 0 && (
        <div>
          <div
            style={{
              fontSize: 9.5,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: "var(--muted)",
              marginBottom: 4,
            }}
          >
            Conditions
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {bail.conditions.map((c, i) => (
              <span
                key={i}
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 4,
                  background: "var(--bg)",
                  border: "1px solid var(--line)",
                  color: "var(--ink-2)",
                }}
              >
                {c}
              </span>
            ))}
          </div>
        </div>
      )}
    </WidgetCard>
  );
}
